module.exports = __webpack_public_path__ + "img/1.d5b74332.png";